<template>
    <v-layout xs12 class="preloader">
        <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0"
             viewBox="0 0 84 76" class="icon-loader"
        >
            <path class="loader" d="M77.9,8.1L66.5,26.5c-1.2,2.1-1.1,3.7-0.5,5.3L83.3,76H11.5C5.1,76,0.1,70.8,0.1,64.7
            L0,5.8c0.2-7.6,11.3-7.7,11.5,0V61c0,1.7,1.5,3.7,3.6,3.7h52.6L54,32.7c-0.4-1.2-0.6-2.4-0.6-3.7c0-1.3,0.6-3.5,1.5-5.3L67.4,3.2
            c0.9-1.8,2.8-3.1,5-3.2c3.1-0.1,5.8,2,5.9,5.3C78.4,6,78.2,7.4,77.9,8.1z M39.1,45.3V5.8c0-7.7,11.3-7.8,11.4,0v39.9
            c0,9.1-6.8,15.2-15.2,15.2c-8.4,0-15.2-6.2-15.2-15.2V5.8c0-7.7,11.4-7.7,11.4,0v39.5C31.4,50.6,39.1,50.9,39.1,45.3z"
            />
        </svg>
    </v-layout>
</template>

<script>
export default {

};
</script>

<style lang="less">
.preloader {
    position: fixed;
    z-index: 5;
    top:0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    opacity: 0.85;
    .icon-loader {
        position: absolute;
        top: 40%;
        left: 48%;
        width: 83px;
        height: 76px;
        .loader{
            fill:#E2173D;
            stroke: #E2173D;
            stroke-dasharray: 700;
            stroke-dashoffset: 700;
            animation: dash 2s linear infinite;
        }
    }
}


@keyframes dash {
    0% {
        fill: rgba(226, 23, 61, 0.24);
        stroke-dashoffset: 700;
    }
    100% {
        stroke-dashoffset: 0;
    }
}
</style>
